import { Box, Typography } from '@mui/material';
import { Facebook, Instagram, LinkIn, Twitter, Youtube } from '../../../../shared/lib/assets';
import palette from '../../../../shared/lib/theme/palette';
import { flexCenter, footerLinks, LinkStyle } from '../../../../shared/lib/theme/styleConstants';
import { LINKS } from '../../app/constants';
import { BRAND_NAME_FULL, COMPANY_NAME_RIGHTS, LABEL_YEAR_COPYRIGHT_REGISTERED } from '../../../../shared/lib/constants';
import { withTrademark } from '../../../../shared/lib/common/Tokenizer';
import { Link } from 'react-router-dom';

export const DashboardFooter = () => {
  const { lightTwo, blackOne } = palette;

  return (
    <Box sx={{ ...flexCenter, flexDirection: 'column', padding: '20px 0px', backgroundColor: lightTwo }}>
      <Box sx={footerLinks}>
        <a target="_blank" rel="noopener noreferrer" href={LINKS.FACEBOOK_LINK}>
          <Box height="100%" width="100%">
            {Facebook()}
          </Box>
        </a>

        <a target="_blank" rel="noopener noreferrer" href={LINKS.INSTAGRAM_LINK}>
          <Box height="100%" width="100%">
            {Instagram()}
          </Box>
        </a>

        <a target="_blank" rel="noopener noreferrer" href={LINKS.LINKEDIN_LINK}>
          <Box height="100%" width="100%">
            {LinkIn()}
          </Box>
        </a>

        <a target="_blank" rel="noopener noreferrer" href={LINKS.TWITTER_LINK}>
          <Box height="100%" width="100%">
            {Twitter()}
          </Box>
        </a>

        <a target="_blank" rel="noopener noreferrer" href={LINKS.YOUTUBE_LINK}>
          <Box height="100%" width="100%">
            {Youtube()}
          </Box>
        </a>
      </Box>

      <Box sx={{ width: '100%', padding: '0 20px', boxSizing: 'border-box' }}>
        <Typography variant="body2" align="center" sx={{ color: blackOne, marginTop: '10px' }}>
          {LABEL_YEAR_COPYRIGHT_REGISTERED} {withTrademark(COMPANY_NAME_RIGHTS)}{' '}
          <span style={{ whiteSpace: 'nowrap' }}>&amp; {withTrademark(BRAND_NAME_FULL)}. All rights reserved.</span>
        </Typography>
      </Box>

      <Box sx={{ width: '100%', padding: '0 20px', boxSizing: 'border-box', marginTop: '10px' }}>
        <Typography variant="body2" align="center" sx={{ color: blackOne }}>
          <Link to={LINKS.TERMS_AND_CONDITIONS_LINK} target="_blank" rel="noopener noreferrer" style={LinkStyle}>
            Terms and Conditions
          </Link> | <Link to={LINKS.PRIVACY_POLICY_LINK} target="_blank" rel="noopener noreferrer" style={{ ...LinkStyle, marginLeft: '0px' }}>
            Privacy Policy
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};
